import { useMutation } from "@tanstack/react-query";
import modalStore from "stores/ModalStore";
import { updateOrderMapping } from "views/setting/services/connectionService";

/**
 * 매장 연동 요청 훅
 */
export const useMappingMutaion = (rootStore: any) => {
  const { layerStore, settingStore, searchStore } = rootStore;

  return useMutation({
    mutationFn: (variables: { bizNo: string; action: boolean; cd: string; posNo: string }) => {
      const payload = {
        bizNo: variables.bizNo,
        mappingAction: variables.action,
        mappingCd: variables.cd,
        posNo: variables.posNo,
        mappingType: layerStore.tp,
        shopCd: searchStore.getShopCd,
        shopNm: searchStore.getSession.shopNm,
        telNo: settingStore.getDlvRegistInfo.telNo,
        contactPossibleTime: settingStore.getDlvRegistInfo.contactPossibleTime,
      };
      return updateOrderMapping(rootStore, payload);
    },

    onSuccess: data => {
      if (data.resultCode === "000") {
        settingStore.setDlvRegistInfo("telNo", "");
        settingStore.setDlvRegistInfo("contactPossibleTime", "");
      } else {
        layerStore.setDlvConnectTypeView(`${layerStore.tp}_FAIL`);
      }
    },

    onError: error => {
      console.error("매장 연동 실패", error);
      layerStore.setDlvConnectTypeView(`${layerStore.tp}_FAIL`);
      layerStore.setLayerLoadingView(false);
    },

    onSettled: () => {
      settingStore.setShopBizNo("");
      modalStore.closeModal("DeliveryConnectPosPick");
      layerStore.setLayerCompleteView(true);
    },
  });
};
